import { openExperiment } from "./needle/experiments"
import { initPostMessageHandler } from "./needle/postMessageHandler"
import { initShopsOnPageListener } from "./needle/initShopsOnPage"
import { openStorefrontAnchor, openStorefront } from "./needle/openStorefront"
import { cssSelectorForShops } from "./needle/helpers"

window.OneO ||
  (function () {
    let scriptSrc = new URL(document.currentScript.src)
    window.OneO = {
      openStorefront,
      openExperiment,
      shopEnv: {
        checkoutAppBase: scriptSrc.origin,
        apiBase: scriptSrc.origin + "/shops_api",
        publicApiBase: scriptSrc.origin + "/shops_public_api",
        graphqlApiBase: scriptSrc.origin + "/graphql"
      }
    }

    initPostMessageHandler()
    initShopsOnPageListener()

    document.addEventListener("click", (event) => {
      const anchor = event.target.closest(cssSelectorForShops())
      if (anchor) {
        event.preventDefault()
        openStorefrontAnchor(anchor, true, true)
      }
    })
  })()
